import ActionType from 'actions/ActionType'

export default (state = 'funnel', action) => {
  switch (action.type) {
    case ActionType.Campaign.TOGGLE_FUNNEL_CALENDAR_VIEW:
      return action.payload
    default:
      return state
  }
}
